/*
# -----------------------------------------------------------------------------
# Component: creditNoteFilterMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 10/May/2019
# Comments: Responsible for all search filter functionality for Manage CreditNote
# -----------------------------------------------------------------------------
*/
export const creditNoteFilterMixin = {
  data() {
    return {
      branches: [],
      creditNoteForm: {
        branch: null,
        accountNo: null,
        documentNo: null,
        transactionType: null,
        fund: null,
        transactionDateFrom: null,
        transactionDateTo: null,
        currency: null,
        actionName: null,
        applyFilters: ''
      },
      creditNoteFormLabel: {
        branch: 'Branch',
        accountNo: 'Account No.',
        documentNo: 'Document No.',
        transactionType: 'Transaction Type',
        fund: 'Fund',
        transactionDateFrom: 'Transaction Date From',
        transactionDateTo: 'Transaction Date To',
        transactionDate: 'Transaction Date',
        currency: 'Currency'
      },
      showBranchHelpList: false,
      filtersBranchLabel: {
        branch: 'Branch'
      },
      filtersBranch: {
        branch: undefined
      },
      branchItems: [],
      totalItemsBranch: 0,
      branchHeaders: [
        { text: 'Branch', align: 'left', value: 'branch' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationBranch: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showAcctNoHelpList: false,
      filtersAcctNoLabel: {
        accountNo: 'Account No.'
      },
      filtersAcctNo: {
        accountNo: undefined
      },
      acctNoItems: [],
      totalItemsAcctNo: 0,
      acctNoHeaders: [
        { text: 'Account No.', align: 'left', value: 'accountNo' },
        { text: 'Name', value: 'intermediaryName' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationAcctNo: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showDocNoHelpList: false,
      filtersDocNoLabel: {
        documentNo: 'Document No.'
      },
      filtersDocNo: {
        documentNo: undefined
      },
      docNoItems: [],
      totalItemsDocNo: 0,
      docNoHeaders: [
        { text: 'Document No.', align: 'left', value: 'documentNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationDocNo: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      showCurrencyHelpList: false
    }
  },
  methods: {
    doClearFilters() {
      var thisPage = this
      this.defaultFilter = {}

      // Iterate through each object field, key is name of the object field
      Object.keys(this.creditNoteForm).forEach(function(key, index) {
        thisPage.creditNoteForm[key] = ''
      })
      this.performSearch()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('creditNoteForm').then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.creditNoteForm.applyFilters = 'Yes'
          this.performSearch()
        }
      })
    }
  },
  watch: {
    'paginationAcctNo': function (value) {
      this.fetchAcctNoData()
    },
    'paginationBranch': function (value) {
      this.fetchBranchData()
    }
  }
}
